import { DateCell } from './table-cells';

type CreatedRowInfoProps = {
    row: {
        createdAt?: Date | string;
        createdBy?: string;
    };
};
export const CreatedRowInfo = ({ row }: CreatedRowInfoProps) => {
    return (
        <div className="d-flex gap-1">
            <div>{row.createdBy}</div>
            {row.createdAt && row.createdBy && <div>@</div>}
            <DateCell value={row.createdAt} />
        </div>
    );
};
